export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms))

export const safeInvoke = <T>(callback: () => T) => {
  try {
    return callback()
  } catch {
    // ignore
  }
}
